<div class="system-container">
  <div class="container">
    <div class="row justify-content-center mt-5">
      <div class="col-auto d-none d-xl-flex my-auto text-center">
        <img src="assets/images/login.png" class="img img-fluid">
      </div>
      <div class="col-auto">
        <div class="p-3 p-sm-2 my-4">
          <!-- จอใหญ่ (lg ขึ้นไป) แสดง 2 บรรทัด -->
          <div class="d-none d-lg-block"
               style="color: inherit; text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white;">
            <div class="fs-2 fs-sm-3 fs-md-2 text-center mb-2 lh-base text-break extra-bold">
              ระบบตามสอบสินค้าเกษตรบนระบบคลาวด์
            </div>
            <div class="fs-2 fs-sm-3 fs-md-2 text-center lh-base text-break extra-bold">
              (QR Trace on Cloud)
            </div>
          </div>

          <!-- จอเล็ก (ต่ำกว่า lg) แสดง 4 บรรทัด -->
          <div class="d-block d-lg-none"
               style="color: inherit; text-shadow: -1px 0 white, 0 1px white, 1px 0 white, 0 -1px white;">
            <div class="fs-2 fs-sm-3 fs-md-2 text-center mb-2 lh-base text-break extra-bold">

            </div>
            <div class="fs-2 fs-sm-3 fs-md-2 text-center mb-2 lh-base text-break extra-bold">
              ระบบตามสอบสินค้าเกษตรบนระบบคลาวด์
            </div>
            <div class="fs-2 fs-sm-3 fs-md-2 text-center lh-base text-break extra-bold">
              (QR Trace on Cloud)
            </div>
          </div>
        </div>
        <div class="row row-cols-1 justify-content-center">
          <div class="col-auto">
            <div class="card my-3 border-0 card-login mx-xl-5">
              <div class="card-body p-0">
                <div class="row">
                  <div class="col-12 mb-3">
                    <img src="assets/images/logo_acfs.png" class="logo">
                  </div>
                  <div class="col-12 mt-3">
                    <div class="row">
                      <div class="d-grid gap-2 col-12 mx-auto">
                        <button type="button"
                                class="btn btn-custom btn-custom-theme d-block"
                                (click)="login()">
                          <i class="bi bi-key fs-5 me-1"></i>
                          Login เข้าใช้งานระบบ
                        </button>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="d-grid gap-2 col-12 mx-auto">
                        <button type="button"
                                class="btn btn-custom btn-custom-theme d-block"
                                (click)="register()">
                          <i class="bi bi-file-earmark-text fs-5 me-1"></i>
                          ลงทะเบียนผู้ใช้ใหม่
                        </button>
                      </div>
                    </div>


                    <!--             <div class="text-center justify-content-center">
                                   <button type="button"
                                           class="btn btn-custom btn-custom-theme me-3 fs-5"
                                           (click)="login()">
                                     <i class="bi bi-key fs-5 me-1"></i>
                                     Login เข้าใช้งานระบบ
                                   </button>
                                   <br/>
                                   <button type="button"
                                           class="btn btn-custom btn-light me-2 fs-5"
                                           (click)="register()">
                                     <i class="bi bi-key fs-5 me-1"></i>
                                     ลงทะเบียนผู้ใช้ใหม่
                                   </button>
                                 </div>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sub-title">
          ท่านสามารถลงทะเบียนสมัครสมาชิกเพื่อเข้าสู่ระบบตามสอบสินค้าเกษตร<br class="d-none d-sm-inline">บนระบบคลาวด์ (QR
          Trace on Cloud)
          โดยต้องทำการพิสูจน์ตัวตนผ่าน ThaID <br class="d-none d-sm-inline">และ ทางอีเมลที่ระบบจัดส่งให้
          โดยคลิกที่ ลงทะเบียนผู้ใช้ใหม่<br><br>
          ติดต่อผู้ดูแลระบบ<br>
          หากต้องการความช่วยเหลือ หรือไม่พบข้อมูลที่ต้องการ<br>
          <a type="button" class="link-primary fw-bold" (click)="openQrcodeJoinGroupModal()"><i
            class="bi bi-link-45deg"></i> คลิกที่นี่เพื่อสแกน QR Code เข้าร่วมกลุ่ม</a><br>
          <a type="button" class="link-primary fw-bold" href="https://youtu.be/Xe-GS6vIxBg?si=iN9TTH40C6XH26Dg"
             target="_blank"><i class="bi bi-play-btn-fill"></i> คลิกที่นี่เพื่อดูวิดีโอขั้นตอนการใช้งานระบบ</a>
        </div>
      </div>
    </div>
  </div>
  <div class="text-end fixed-bottom">
    <div class="px-3 pb-2 mt-3">
      <span class="form-text mb-0 mt-0 p-0 pb-0 text-muted">version. {{ version?.version }}</span>
    </div>
  </div>
</div>

